/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
// import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Images
// import concreteScreeding from "assets/images/concrete_screeding.jpg";
// import concreteCutting from "assets/images/concrete_cutting.jpg";
// import cleaning from "assets/images/cleaning.jpg";
// import constructionSite from "assets/images/production/construction-site.jpg";

// const gallery = [
//   {
//     id: "gallery-1",
//     title: "Built for precision",
//     image: concreteScreeding,
//   },
//   {
//     id: "gallery-2",
//     title: "Engineered cuts",
//     image: concreteCutting,
//   },
//   {
//     id: "gallery-3",
//     title: "Site-ready finish",
//     image: cleaning,
//   },
// ];

function AboutCompany() {
  return (
    <MKBox component="section" py={6} height="50vh">
      <Container>
        <Grid container item xs={12} md={8} sx={{ mx: "auto", textAlign: "left", mb: 6 }}>
          <MKTypography variant="h3" mb={1}>
            About Us
          </MKTypography>
          <MKTypography variant="body1" color="text" mt={5}>
            We deliver reliable construction services with a focus on safety, quality, and
            predictable timelines. From planning to handover, our teams work with clear processes,
            modern equipment, and a commitment to doing the job right.
          </MKTypography>
        </Grid>

        {/* <Grid container spacing={3}>
          {gallery.map(({ id, title, image }) => (
            <Grid key={id} item xs={12} sm={6} md={3}>
              <Card
                sx={({
                  boxShadows: { md },
                  borders: { borderRadius },
                  palette: { background },
                }) => ({
                  height: "100%",
                  overflow: "hidden",
                  borderRadius: borderRadius.lg,
                  backgroundColor: background.paper,
                  transition: "transform 300ms ease, box-shadow 300ms ease",
                  "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow: md,
                  },
                })}
              >
                <MKBox position="relative">
                  <MKBox
                    component="img"
                    src={image}
                    alt={title}
                    width="100%"
                    height="200px"
                    sx={{ objectFit: "cover" }}
                  />
                  <MKBox
                    sx={({ palette: { black }, functions: { rgba } }) => ({
                      position: "absolute",
                      inset: 0,
                      background: `linear-gradient(180deg, ${rgba(black.main, 0)} 35%, ${rgba(
                        black.main,
                        0.75
                      )} 100%)`,
                      display: "flex",
                      alignItems: "flex-end",
                      p: 2,
                    })}
                  >
                    <MKTypography variant="h6" color="white">
                      {title}
                    </MKTypography>
                  </MKBox>
                </MKBox>
              </Card>
            </Grid>
          ))}
        </Grid> */}
      </Container>
    </MKBox>
  );
}

export default AboutCompany;
